import { SET_RECIPIENTS_WITHOUT_EMAIL_ID } from "../../redux/actions/action.types";

export default function setRecipientsWithoutEmailId(stateHandler: any, recData: any) {
  stateHandler({
    type: SET_RECIPIENTS_WITHOUT_EMAIL_ID,
    payload: recData,
  });
}
